import * as React from "react";
import { Link } from "@/components/common/Link";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
export default function PrecisionCareTeaser() {
  return <section id="precision-care-teaser" className="dark bg-background text-foreground relative flex min-h-[600px] w-full items-center justify-center overflow-hidden py-24">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-black/60 z-10" />
        <div className="h-full w-full bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1560445/img/mechanic_bay_dark.png)] bg-cover bg-center bg-no-repeat" />
      </div>

      {}
      <div className="relative z-20 container mx-auto px-4 flex justify-center">
        <Card className="max-w-2xl w-full border-white/10 bg-black/20 backdrop-blur-xl shadow-2xl">
          <CardHeader className="text-center space-y-4 pt-10 pb-2">
            <CardTitle className="text-4xl md:text-5xl font-bold tracking-tight text-white">
              Technical Excellence
            </CardTitle>
            <div className="mx-auto h-1 w-20 rounded-full bg-primary/80" />
          </CardHeader>
          <CardContent className="text-center pb-10 px-6 md:px-12 space-y-8">
            <CardDescription className="text-lg md:text-xl text-gray-200 leading-relaxed">
              Every vehicle in our fleet undergoes a rigorous 150-point inspection by certified master mechanics. 
              We prioritize safety and reliability above all else, ensuring your journey is smooth and worry-free.
            </CardDescription>
            
            <div className="flex justify-center pt-4">
              <Button asChild size="lg" className="h-14 px-8 text-lg font-medium shadow-[0_0_20px_rgba(59,130,246,0.3)] hover:shadow-[0_0_30px_rgba(59,130,246,0.6)] transition-all duration-300 hover:scale-105 border-primary/20">
                <Link to="/PrecisionCareCenterPage">
                  Explore Service Center
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}